var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('loading',{attrs:{"show":_vm.isLoading,"text":'Please wait...'}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }